module.exports = __webpack_public_path__ + "static/media/マルチメディア研究部.d7c36071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/マルチメディア研究部.png
// module id = 305
// module chunks = 10